import type { IBuilderContentData } from '../schemas/IBuilderContentData';

export const MOCK_BUILDER_CONTENT = {} as IBuilderContentData<'page'>;
